export * from './nr.component';



// WEBPACK FOOTER //
// ./src/shared/no-records.component/index.ts